/* DOMNO. popup tracking (12 Oct 2026, built by Claude).
   Watches whichever sign-up popup this visitor got (spin wheel #ds-root or cards #dc-root) and sends each step to:
   - Intelligems  (window.igEvents) so every step shows per test group, and results can be filtered by who did what
   - Klaviyo      ("Spin Popup Viewed" / "Cards Popup Viewed") so the sign-up rate can be read the way Klaviyo
                  reads its own forms: people who SIGNED UP divided by people who SAW IT, both counted per person.
                  Intelligems' visitor count is inflated (it splits one real person into ~2.5 "visitors"), so its
                  own rate is wrong on absolutes. The sign-up events already land in Klaviyo
                  ("Spin Popup Submitted" / "Cards Popup Submitted"), so putting the VIEW in Klaviyo too means
                  both halves of the fraction are counted by the same system against the same identity. See kview().
   - Clarity      (session tag "popup" = spin / cards, plus one Clarity event per step) so recordings can be filtered
   - dataLayer    (popup_<step>) for GA4 if wanted
   It never changes the popups. Each step is sent at most once per page view.
   Runs only for live test traffic: window.DOMNO_POPUP set by Intelligems and no ?dp= in the URL.
   To check it without sending anything: add &dp_track=1 to a demo link (e.g. ?dp=cards&dp_track=1) and watch the console. */
(function () {
  'use strict';
  var qs = new URLSearchParams(location.search);
  var TEST = qs.get('dp_track') === '1';

  /* Klaviyo, for the view event only. Same company id and revision the popups themselves use
     (see assets/domno-spin-1.js / domno-cards-1.js CFG). */
  var K_COMPANY = 'STCDP5';
  var K_REVISION = '2025-01-15';

  // ?dp_reset=1 forgets this browser has seen, closed or used either popup (for testing as a brand-new visitor)
  if (qs.get('dp_reset') === '1') {
    try { ['done', 'snooze', 'ds_done', 'ds_snooze', 'dc_done', 'dc_snooze'].forEach(function (k) { localStorage.removeItem(k); }); } catch (e) {}
    try { Object.keys(localStorage).forEach(function (k) { if (/^(ds|dc)[_:-]/.test(k)) localStorage.removeItem(k); }); } catch (e) {}
    try { Object.keys(sessionStorage).forEach(function (k) { if (/^(ds|dc)[_:-]/.test(k)) sessionStorage.removeItem(k); }); } catch (e) {}
  }

  /* One id per browser, kept forever, so Klaviyo counts one person once however many pages they look at.
     This is the same trick Klaviyo's own forms use for their "viewed form" number — it is why their
     submit rate is a people rate and not a sessions rate. If localStorage is unavailable (private mode,
     blocked storage) we fall back to a per-page id: that visitor is then counted once per page view
     rather than once overall, which can only make the measured rate look WORSE, never better. */
  function anonId() {
    var k = 'dp_anon';
    try {
      var v = localStorage.getItem(k);
      if (v) return v;
      v = 'dp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
      localStorage.setItem(k, v);
      return v;
    } catch (e) {
      return 'dp-nostore-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    }
  }

  /* The denominator. Fired once per page view when the popup actually opens, against the browser id above.
     Two separate metric names rather than one metric with a variant property, because Klaviyo's reporting
     can group by metric but not by an arbitrary event property — one metric per arm keeps each arm's
     unique-people count directly readable. Anonymous profiles are free in Klaviyo (billing is on
     subscribed profiles), and Klaviyo's own forms create them the same way. */
  function kview(type) {
    var metric = (type === 'spin' ? 'Spin' : 'Cards') + ' Popup Viewed';
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + K_COMPANY, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': K_REVISION },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: { popup_variant: type, page: location.pathname },
              metric: { data: { type: 'metric', attributes: { name: metric } } },
              profile: { data: { type: 'profile', attributes: { anonymous_id: anonId() } } }
            }
          }
        })
      }).catch(function () {});
    } catch (e) {}
  }

  function start(type) {
    var p = type === 'spin' ? 'ds' : 'dc';
    var root = document.getElementById(p + '-root');
    if (!root || root.getAttribute('data-tracked')) return;
    root.setAttribute('data-tracked', '1');
    var sent = {}, openAt = 0, wasOpen = false, played = false, signed = false, typed = false;

    function send(id) {
      if (sent[id]) return;
      sent[id] = 1;
      if (TEST) { (window.__dpTrack = window.__dpTrack || []).push(id); try { console.log('[popup-track]', type, id); } catch (e) {} return; }
      try { window.igEvents = window.igEvents || []; window.igEvents.push({ event: id }); } catch (e) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', id); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'popup_' + id, popup_type: type }); } catch (e) {}
      if (id === 'domnoPopupSeen') kview(type);
    }
    if (!TEST) { try { if (typeof window.clarity === 'function') window.clarity('set', 'popup', type); } catch (e) {} }

    function q(s) { return root.querySelector(s); }
    function shown(s) { var el = q(s); return !!el && !el.hidden; }
    function won() { return p === 'ds' ? root.classList.contains('is-won') : !!q('.dc-card.is-match'); }

    function onClose() {
      if (signed) return;
      send('domnoPopupClosedNoSignup');
      if (!played && Date.now() - openAt < 5000) send('domnoPopupClosedFast');
      if (shown('.' + p + '-step[data-step="form"]')) send('domnoPopupClosedAtForm');
      if (typed) send('domnoPopupNearlySignedUp');
    }
    function check() {
      var open = root.classList.contains('is-open');
      if (open && !wasOpen) { openAt = Date.now(); send('domnoPopupSeen'); }
      if (!open && wasOpen) onClose();
      wasOpen = open;
      if (won()) send('domnoPopupWon');
      if (shown('.' + p + '-step[data-step="code"]') && root.classList.contains('is-existing')) {
        signed = true; // not a new sign-up: already a customer, no code given
        send('domnoPopupExistingCustomer');
      } else if (shown('.' + p + '-step[data-step="code"]')) {
        signed = true;
        send('domnoPopupSignedUp');
        if (shown('[data-' + p + '-sms]')) send('domnoPopupSmsSeen');
      }
      if (shown('[data-' + p + '-entered]')) send('domnoPopupSmsEntered');
    }
    new MutationObserver(check).observe(root, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden'] });
    check();

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest(p === 'ds' ? '[data-ds-spin]' : '.dc-card')) { played = true; send('domnoPopupPlayed'); }
      if (t.closest('[data-' + p + '-copy]')) send('domnoPopupCodeCopied');
      if (t.closest(p === 'ds' ? '.ds-btn--end' : '[data-dc-shop]')) send('domnoPopupShopClicked');
      if (t.closest('[data-' + p + '-teaser]')) send('domnoPopupReopened');
    }, true);
    function nameDone(el) { if (el && el.name === 'first_name' && (el.value || '').trim().length >= 2) send('domnoPopupNameDone'); }
    root.addEventListener('input', function (e) {
      var el = e.target;
      if (!el.closest || !el.closest('[data-' + p + '-form]') || !(el.value || '').trim()) return;
      if (el.name === 'first_name') { typed = true; send('domnoPopupNameStarted'); }
      if (el.name === 'email') { typed = true; send('domnoPopupEmailStarted'); }
    }, true);
    root.addEventListener('focusout', function (e) { if (e.target.closest && e.target.closest('[data-' + p + '-form]')) nameDone(e.target); }, true);
    root.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches('[data-' + p + '-form]')) nameDone(e.target.elements.first_name);
    }, true);
  }

  // Intelligems sets window.DOMNO_POPUP as the page loads (can be slow on phones). Look for it for 20 seconds.
  var tries = 0;
  (function wait() {
    var dp = qs.get('dp'), type = null;
    if (TEST) type = /^spin/.test(dp || '') ? 'spin' : /^cards/.test(dp || '') ? 'cards' : null;
    else if (!dp) type = window.DOMNO_POPUP;
    if (type === 'spin' || type === 'cards') return start(type);
    if (++tries < 80) setTimeout(wait, 250);
  })();
})();
